import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card, CardActions, CardContent, CardMedia } from '../../Generic/Card';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import cardStyles from './Card-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

class JumboCard extends React.PureComponent {
    constructor(props){
        super(props)
        this.state = {showMore: false}
    }
    showMore = () => {
        // eslint-disable-next-line react/destructuring-assignment
        if(this.state.showMore){
            this.setState({showMore:false})
        }else{
            this.setState({showMore:true})
        }
       
}
  render() {
    const {
      cardType,
      data,
    } = this.props;
    const { showMore } = this.state ;
    const defaultCardTypeStyle = 'stackedCard';
    const requestedCardTypeStyle =
      (data.styles && data.styles.trim()) || cardType || defaultCardTypeStyle;
    const cardTypestyle =
      cardStyles[requestedCardTypeStyle] !== undefined
        ? requestedCardTypeStyle
        : defaultCardTypeStyle;
    const resolvedCardStyle = cardStyles[cardTypestyle] || cardStyles[defaultCardTypeStyle];

    const mediaProps = {
      type: i18nMessages.img,
      src:
        data.image && data.image.image
          ? data.image.image.url && data.image.image.url
          : null,
      alt: data.image && data.image.altText,
      tooltip: data.image && data.image.tooltip,
    };
    const widthClass = getWidth(data.componentWidth);

    let cardMedia = '';
    if (mediaProps.src) {
      cardMedia = (
        <CardMedia
          className={classNames(resolvedCardStyle.cardMedia)}
          image={getCdnImage(mediaProps.src, { w: 800 })}
          srcset={getCdnSrcset(mediaProps.src, 800)}
          component={mediaProps.type}
          alt={mediaProps.alt}
          cardType={cardTypestyle}
        />
      );
    } else if (data.image && data.image.__typename === i18nMessages.ImageSet) {
      cardMedia = (
        <CardMedia
          className={classNames(resolvedCardStyle.cardMedia)}
          image={
            data.image &&
            data.image.smartphoneImage &&
            data.image.smartphoneImage.url
          }
          component="picture"
          sizes={mediaProps && mediaProps.sizes}
          srcset={
            data.image && data.image.desktopImage && data.image.desktopImage.url
          }
          alt={mediaProps.alt}
          cardType={cardType}
        />
      );
    }
    let cardMediaLink = '';
    if (
      data.callToActionsCollection &&
      data.callToActionsCollection.items.length > 0 &&
      data.callToActionsCollection.items[0] !== 'VER MENOS' &&
      data.callToActionsCollection.items.some(
        obj => obj && obj.__typename !== i18nMessages.VideoButton
      )
    ) {
      cardMediaLink = cardMedia;
    } else {
      cardMediaLink = cardMedia;
    }
    return (
      <Card
        key={data.sys.id}
        className={classNames(widthClass, resolvedCardStyle.card)}
      >
        <div className={classNames(resolvedCardStyle.mediaWrapper)}>
          <div className={classNames(resolvedCardStyle.cardMedia)}>
            {cardMediaLink}
          </div>

          <CardContent
            className={classNames(resolvedCardStyle.cardContent)}
          >
            {data.title && (
            <Typography
              className={classNames(resolvedCardStyle.header)}
              component="h2"
              dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.title),
                  }}
            />
              )}
            {data.subTitle && (
              <Typography
                className={classNames(resolvedCardStyle.subTitle)}
                component="div"
                dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.subTitle),
                  }}
              />
              )}
            {data.text &&showMore && (
            <Typography
              className={classNames(resolvedCardStyle.description)}
              component="div"
              dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.text),
                  }}
            />
              )}
          </CardContent>

          {data.callToActionsCollection &&
            data.callToActionsCollection.items.length > 0 && (
              <CardActions
                className={classNames(resolvedCardStyle.cardActions)}
              >
                {data.callToActionsCollection.items.map((action, i) => {
                  return <Button onClick={this.showMore} key={i}>{showMore ? action.link : action.linkText}</Button>
                })}
              </CardActions>
            )}
        </div>
      </Card>
    );
  }
}

JumboCard.propTypes = {
  cardType: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const JumboCard = ({prop = val, cardType = 'stackedCard' }) =>

export default JumboCard;
